import { computed } from 'vue';

import {
  SIMPLE_CHOICE,
  SIMPLE_CHOICE_META,
} from '@/features/ChoicesLists/Simple/types';
import type { ConditionalRequestDefinition } from '@/utils/dehydrateRequestData/types';
import { getSimpleChoiceMeta } from '@/utils/getSimpleChoiceMeta/getSimpleChoiceMeta';
import {
  hasHsnTsn,
  isCarChange,
  isEvbVisible,
  isSecondCarReactive,
} from '@/features/Sparten/shared/renderConditions/kfz/sharedRenderConditions';
import { useContractStore } from '@/features/Sparten';
import { kfzPreviousInsurance } from '@/features/Sparten/shared/utils/hasPreviousInsurance';

export const isNoExtendedCar: ConditionalRequestDefinition = {
  if: computed(() => !isCarChange.value),
  drop: ['vorfahrzeug'],
};

export const isExtendedButNotSecondCar: ConditionalRequestDefinition = {
  if: computed(() => !isSecondCarReactive.value),
  drop: ['erstfahrzeug'],
};

export const isNotEvbVisible: ConditionalRequestDefinition = {
  if: computed(() => !isEvbVisible.value),
  drop: ['evb'],
};

export const isHasNotEvb: ConditionalRequestDefinition = {
  if: computed(
    () => isEvbVisible.value && useContractStore().evb.willBeProvidedLater,
  ),
  drop: ['evb.vorhandeneEvb'],
};

export const isEvbSameDay: ConditionalRequestDefinition = {
  if: computed(
    () =>
      isEvbVisible.value &&
      useContractStore().evb.vorhandeneEvb
        .evbVersicherungsbeginnAmTagDerZulassung,
  ),
  drop: ['evb.vorhandeneEvb.evbVersicherungsbeginn'],
};

export const isNoVorversicherung: ConditionalRequestDefinition = {
  if: computed(() => !kfzPreviousInsurance()),
  drop: ['vorversicherungsDaten'],
};

export const isVorfahrzeugNotAbgemeldet: ConditionalRequestDefinition = {
  if: computed(
    () =>
      !getSimpleChoiceMeta(
        SIMPLE_CHOICE.VORFAHRZEUG_VERBLEIB,
        SIMPLE_CHOICE_META.VORFAHRZEUG_IST_ABGEMELDET_VERKAUFT,
      ).includes(useContractStore().vorfahrzeug.verbleib),
  ),
  drop: ['vorfahrzeug.datum'],
};

export const hasHersteller: ConditionalRequestDefinition = {
  if: hasHsnTsn,
  drop: ['fahrzeugdaten.hersteller'],
};
